var map = {
	"./br/PT/S1/bg105.png": 10605,
	"./br/PT/bg105.png": 74143,
	"./in/EN/S1/bg105.png": 47229,
	"./ph/EN/S1/bg105.png": 74111,
	"./ph/EN/bg105.png": 40335,
	"./vn/VI/S1/bg105.png": 78932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46040;